import MuiTypography from '@mui/material/Typography';
import type { TypographyProps } from './ITypography';
import { styles } from './styles';

const Typography = ({ sx, ...rest }: TypographyProps) => (
    <MuiTypography
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default Typography;
